import { render, staticRenderFns } from "./customPermissions-G.vue?vue&type=template&id=37ae9cb6&scoped=true&"
import script from "./customPermissions-G.vue?vue&type=script&lang=js&"
export * from "./customPermissions-G.vue?vue&type=script&lang=js&"
import style0 from "./customPermissions-G.vue?vue&type=style&index=0&id=37ae9cb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ae9cb6",
  null
  
)

export default component.exports